enum BlogPostStatus {
    None,
    Draft,
    Published,
    WaitingForApproval
}

export default BlogPostStatus
